

















































































































import {Component, Inject, Watch} from "vue-property-decorator";
    import UserRequired from "@/components/UserRequired";
    import {
      GeofenceStatusCode,
      RegReminderConfig, NotificationManagerStatus,
      PersonRegreminderLocation, BackgroundLocationPermission,
    } from "@/modules/models";
    import Api from "@/components/start/Api";
    import {NativeApi} from "@/modules/NativeBridge";
    import RegreminderInfoDialog from "@/components/sio/RegreminderInfoDialog.vue";
    import {MaxRegreminderLocationsPerUser} from "@/modules/constants";
    import EnableBackgroundLocationDlg from "@/components/sio/EnableBackgroundLocationDlg.vue";
    import CommonBase from "@/components/CommonBase";
    import GeoApi, {
      geoDeniedNonPromptable,
      geoGranted,
      geoGrantedInaccurateNonpromptable,
      geoGrantedInaccuratePromptable, geoNotAvailable,
      geoNotPrompted
    } from "@/store/modules/geo";

    @Component({
        components: {
          "at-regreminder-info-dialog": RegreminderInfoDialog,
          "at-enable-background-location": EnableBackgroundLocationDlg,
        }
    })
    export default class UserRegreminderPage extends UserRequired {
        @Inject()
        api!: Api;
        @Inject()
        nativeApi!: NativeApi;
        @Inject()
        geoApi!: GeoApi;

        locations: PersonRegreminderLocation[] = [];
        loading = false;

        get isGeoGrantedInaccuratePromptable() {
          return this.geoApi.availability === geoGrantedInaccuratePromptable;
        }
        get isGeoNotPrompted() {
          return this.geoApi.availability === geoNotPrompted;
        }
        get isGeoDeniedNonPromptable() {
          return this.geoApi.availability === geoDeniedNonPromptable;
        }
        get isGeoGrantedInaccurateNonpromptable() {
          return this.geoApi.availability === geoGrantedInaccurateNonpromptable;
        }
        get isGeoNotAvailable() {
          return this.geoApi.availability === geoNotAvailable;
        }
        get isMissingBackgroundGeoPermission() {
          return this.statusCode === GeofenceStatusCode.MissingBackgroundPermission;
        }
        get isGeoGranted() {
          return this.geoApi.availability === geoGranted;
        }

        @Watch("isGeoGranted")
        async onIsGeoGrantedChanged(now, was) {
          if(now && !was) {
            await this.loadRegReminderConfig();
            if(this.isMissingBackgroundGeoPermission) {
              this.emitSnack(`Du kan nå oppjustere posisjonstilgang til "hele tiden"`, "info");
            }
          }
        }

        async loadLocations() {
            try {
                this.loading = true;
                this.locations = await this.api.fetchUserRegreminderLocations();
            } catch (e) {
                this.emitError(e);
            } finally {
                this.loading = false;
            }
        }

        settingRegreminder = 0;
        async setRegreminder(loc: PersonRegreminderLocation) {
            try {
                this.settingRegreminder = loc.terminalLocationId;
                const resp = await this.api.setRegreminder(loc.terminalLocationId, loc.geofenceActive);
                if(resp.removedLocId != null) {
                    this.emitSnack(`Registreringspåminnelse på ${resp.removedLocDescription} ble deaktivert. (Maks ${MaxRegreminderLocationsPerUser} anlegg kan være aktivert samtidig)`, "info");
                }
                // Reload locations incase the setRegreminder call caused other reminders to be deactivated
                await this.loadLocations();
            } finally {
                this.settingRegreminder = 0;
            }
        }


        regReminderConfig: RegReminderConfig | null = null;
        loadingRegReminderConfig = false;
        backgroundLocationPermission = new BackgroundLocationPermission(false, 0);

        get regReminderEnabled(): boolean {
            if(this.regReminderConfig) {
                return this.regReminderConfig.enabled;
            }
            return false;
        }
        set regReminderEnabled(v: boolean) {
            if(this.regReminderConfig) {
                this.regReminderConfig.enabled = v;
                if(v) {
                  // Have an async function inform and prompt user for background position permission consent
                  const promptAndSet = async () => {
                    const ok = await this.promptEnableBackgroundLocation();
                    if(ok) {
                      await this.setRegReminderConfig();
                    } else {
                      if(this.regReminderConfig) {
                        this.regReminderConfig.enabled = false;
                      }
                    }
                  };
                  promptAndSet();
                } else {
                  this.setRegReminderConfig();
                }
            }
        }

        get statusCode() {
            return this.regReminderConfig ? this.regReminderConfig.statusCode : 0;
        }

        get geoError(): string | null {
          if(this.geoApi.availability >= geoGrantedInaccuratePromptable) {
            return `Mangler posisjonstilgang`;
          }
          return null;
        }

        get locationRegReminderError(): string | null {
            return (this.regReminderConfig && this.regReminderConfig.errorMessage) || this.notificationError || this.geoError;
        }

        get locationRegReminderAvailable() {
            return this.nativeApi.available && this.nativeApi.atleastVersion(0, 3, 0);
        }

        async setRegReminderConfig() {
            if(this.regReminderConfig != null) {
                try {
                    this.loadingRegReminderConfig = true;
                    this.regReminderConfig = await this.nativeApi.setRegReminderConfig(this.regReminderConfig);
                } catch (e) {
                    this.regReminderConfig.enabled = false;
                    this.loadRegReminderConfig();
                    throw e;
                } finally {
                    this.loadingRegReminderConfig = false;
                }
            }
        }

        async loadRegReminderConfig() {
            if(this.locationRegReminderAvailable) {
              this.geoApi.checkAvailability();
              await this.loadBackgroundLocationPermission();
              this.regReminderConfig = await this.nativeApi.getRegReminderConfig();
            }
        }

        async loadBackgroundLocationPermission() {
          const possible = this.nativeApi.atleastVersion(1, 3, 0);
          if(possible) {
            this.backgroundLocationPermission = await this.nativeApi.checkBackgroundLocationPermission();
          }
        }

      showEnableBackgroundLocation = false;
      async promptEnableBackgroundLocation(): Promise<boolean> {
        const ref = this.$refs["EnableBackgroundLocationDlg"] as EnableBackgroundLocationDlg;
        const retPromise = CommonBase.oneEventPromise(ref, "at-enable-background-location").then(r => r === true);
        this.showEnableBackgroundLocation = true;
        const ret = await retPromise;
        this.showEnableBackgroundLocation = false;
        return ret;
      }

      async fixLocationSettings() {
        try {
          await this.loadBackgroundLocationPermission();
          if (!this.backgroundLocationPermission?.background) {
            if (this.backgroundLocationPermission?.askAllowed()) {
              // If geofencing is enabled, try reactivating it now. If not enabled we will refresh the geofencing status anyway
              await this.setRegReminderConfig();
            } else {
              // User must manually adjust permission in settings
              await this.appSettingsFix();
            }
          } else {
            console.info(`Unexpected app state. Fixing location settings, but background location permission was granted`);
            await this.setRegReminderConfig(); // Try activating againg, will refresh the status
          }
        } catch(e) {
          console.error(e);
          this.emitSnack(`Posisjonsinnstillinger ikke korrigert, kan ikke aktivere posisjonstjenester`, "error");
        }
      }

      notificationManagerStatus: NotificationManagerStatus | null = null;
      async loadNotificationManagerStatus() {
        this.notificationManagerStatus = await this.nativeApi.getNotificationManagerStatus();
      }
      async openNotificationSettings() {
        await this.nativeApi.openNotificationSettings();
        this.emitSnack(`Oppdater for å sjekke status på nytt`, "info");
        this.regreminderStatusReloadNeeded = true;
      }

      get notificationError(): string | null {
        return this.regReminderEnabled && this.notificationManagerStatus && this.notificationManagerStatus.regreminderNotificationError() || null;
      }

      regreminderStatusReloadNeeded = false; // Set to true when an app setting or something that could fix regreminder problem may have been resolved, but we have no way of knowing except asking the user to reload it's state.

      async regreminderStatusLoad() {
        await this.loadRegReminderConfig();
        await this.loadNotificationManagerStatus();
        this.regreminderStatusReloadNeeded = false;
      }

      async startGeolistener() {
        await this.geoApi.startGeolistener();
      }

      async appSettingsFix() {
        const opened = await this.nativeApi.openAppSettings();
        if (opened) { // App settings was opened, and user returned to app
          await this.geoApi.checkAvailability();
          if(this.geoApi.availability <= geoGranted) {
            await this.setRegReminderConfig() // Try activating again, will refresh the status.
          }
        } else {
          this.emitSnack(`Åpning av app innstillinger feilet.`, "error");
        }
      }

      created() {
        this.regreminderStatusLoad();
        this.loadLocations();
      }
    }
